import { ArrayRadioButton } from '../../shared/models/hybrid-model/hybrid-model';

export const DEMO_LOCATION_CONFIG = {
  // HARDCODEADO para demo: customer y locationType fijos del backend actual.
  customerId: 2,
  locationTypeId: 1,
  // HARDCODEADO para demo: el backend hoy recibe estos defaults al crear localizacion.
  apartmentNumber: '0',
  priorityId: 0,
  // HARDCODEADO para demo: este proyecto no captura domicilio/contacto (solo activo); usa la geolocalización real en Latitude/Longitude.
  streetName: 'N/A',
  streetNumber: '0',
  telephone: '',
  postalCodeId: 0,
} as const;

// workFlowId 13 es del flujo medical-equipment-leasing; credito usa su propio workFlowId (6), ver DEMO_CREDITO_WORKFLOW_PROJECT_CONFIG.
export const DEMO_WORKFLOW_PROJECT_CONFIG = {
  // HARDCODEADO para demo: flujo y customer actuales del backend.
  customerId: 2,
  workFlowId: 13,
  // HARDCODEADO para demo: pendiente sustituir por un origen real.
  pocEmail: 'contacto@example.com',
} as const;

export const DEMO_CREDITO_WORKFLOW_PROJECT_CONFIG = {
  ...DEMO_WORKFLOW_PROJECT_CONFIG,
  workFlowId: 6,
} as const;

export const DEMO_YES_NO_OPTIONS: ReadonlyArray<ArrayRadioButton> = [
  {
    value: true,
    description: 'Si',
    descriptionKey: 'general.yes',
    colorIcon: '#77a564',
    backgroundColor: '#f4f7e7',
    borderColor: '#c0e0b6',
    icon: 'check',
  },
  {
    value: false,
    description: 'No',
    descriptionKey: 'general.no',
    colorIcon: '#ff0000',
    borderColor: '#ffcccc',
    backgroundColor: '#ffeaea',
    icon: 'close',
  },
];

export const DEMO_EMPLOYMENT_TYPE_OPTIONS: ReadonlyArray<ArrayRadioButton> = [
  {
    value: 1,
    description: 'Nómina',
    descriptionKey: 'credito.features.adoutUser.formsWork.fields.employmentType.options.payroll',
    colorIcon: '#707070',
    backgroundColor: '#fbfbfb',
    borderColor: '#eaeaea',
    icon: 'contract',
  },
  {
    value: 2,
    description: 'Informal',
    descriptionKey: 'credito.features.adoutUser.formsWork.fields.employmentType.options.informal',
    colorIcon: '#707070',
    borderColor: '#eaeaea',
    backgroundColor: '#fbfbfb',
    icon: 'handshake',
  },
];

export const DEMO_HOUSING_TYPE_OPTIONS: ReadonlyArray<ArrayRadioButton> = [
  {
    value: 1,
    description: 'Propia',
    descriptionKey: 'credito.features.adoutUser.formsAddress.fields.housingType.options.owned',
    colorIcon: '#707070',
    backgroundColor: '#fbfbfb',
    borderColor: '#eaeaea',
    icon: 'home',
  },
  {
    value: 2,
    description: 'Rentada',
    descriptionKey: 'credito.features.adoutUser.formsAddress.fields.housingType.options.rented',
    colorIcon: '#707070',
    borderColor: '#eaeaea',
    backgroundColor: '#fbfbfb',
    icon: 'key',
  },
  {
    value: 3,
    description: 'Familiar',
    descriptionKey: 'credito.features.adoutUser.formsAddress.fields.housingType.options.family',
    colorIcon: '#707070',
    backgroundColor: '#fbfbfb',
    borderColor: '#eaeaea',
    icon: 'family_restroom',
  },
  {
    value: 4,
    description: 'Prestada',
    descriptionKey: 'credito.features.adoutUser.formsAddress.fields.housingType.options.borrowed',
    colorIcon: '#707070',
    borderColor: '#eaeaea',
    backgroundColor: '#fbfbfb',
    icon: 'real_estate_agent',
  },
];
